import sensors from "@/lib/thirdparty/sensorsdata.min";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";

export default function track(event_name: any, params: any) {
  // try {
  //   params.company_id = parseInt(Auth.companyId);
  //   params.company_name = vuexStore.company ? vuexStore.company.name : "";
  // } catch (e) {
  //   console.log(e);
  // }
  // sensors.track(event_name, params);
}
